import { jsx as jsx$1 } from '@theme-ui/core';
export { __ThemeUIContext, createElement, merge, useThemeUI } from '@theme-ui/core';
export { InitializeColorMode, useColorMode } from '@theme-ui/color-modes';
export { ThemeProvider, ThemeUIProvider } from '@theme-ui/theme-provider';
export { default as Global } from '@theme-ui/global';
export * from '@theme-ui/components';
export { css, get } from '@theme-ui/css';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const BaseStyles = props => jsx('div', _extends({}, props, {
  sx: _extends({
    fontFamily: 'body',
    lineHeight: 'body',
    fontWeight: 'body',
    variant: 'styles'
  }, props.sx)
}));
const jsx = jsx$1;

export { BaseStyles, jsx };
